import { render, staticRenderFns } from "./user-awb-query.vue?vue&type=template&id=928a7a46&"
import script from "./user-awb-query.vue?vue&type=script&lang=js&"
export * from "./user-awb-query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports